import { DEFAULT_BREAKPOINT_NAME } from '../constants';
import { buildBackgroundLayerClassname } from './classNameUtils';
export function isMediaQuery(config) {
  return config.type === 'mediaQuery';
}
export function buildNodeSelector({
  parentSelector = '',
  targetSelector = '',
  breakpointConfig
}) {
  const selectorBase = parentSelector ? `${parentSelector} ${targetSelector}` : targetSelector;
  if (isMediaQuery(breakpointConfig)) {
    return selectorBase;
  } else {
    const {
      attributeName,
      attributeValue,
      childBreakpoints
    } = breakpointConfig;
    let selector = `[${attributeName}="${attributeValue}"] ${selectorBase}`;
    childBreakpoints === null || childBreakpoints === void 0 || childBreakpoints.forEach(childBreakpoint => {
      // The :where() is to support overriding styles from parent breakpoints
      // since :where() does not increase specificity.
      selector = `:where([${childBreakpoint.attributeName}="${childBreakpoint.attributeValue}"]) ${selectorBase}, ${selector}`;
    });
    return selector;
  }
}
export default function combineBreakpointStyles(breakpointConfigs, stylesByBreakpointName, nodeId, backgroundLayerStylesByBreakpointName, nodeSelector) {
  return breakpointConfigs.flatMap(breakpointConfig => {
    const {
      breakpointName
    } = breakpointConfig;
    const selector = buildNodeSelector({
      targetSelector: nodeSelector,
      breakpointConfig
    });
    const mediaQuery = isMediaQuery(breakpointConfig) ? breakpointConfig.mediaQuery : '';
    const backgroundLayerClassname = buildBackgroundLayerClassname(nodeId, breakpointName);
    const rules = [];
    if (breakpointName === DEFAULT_BREAKPOINT_NAME) {
      const stylesForBreakpoint = stylesByBreakpointName[breakpointName];
      if (stylesForBreakpoint && stylesForBreakpoint.length > 0) {
        rules.push([selector, stylesForBreakpoint.join(' '), '']);
      }
      const backgroundLayerStyles = backgroundLayerStylesByBreakpointName[breakpointName];
      if (backgroundLayerStyles && backgroundLayerStyles.length > 0) {
        rules.push([buildNodeSelector({
          parentSelector: nodeSelector,
          targetSelector: `> .dnd-grid-background > :not(.${backgroundLayerClassname})`,
          breakpointConfig
        }), 'display: none;', mediaQuery]);
        rules.push([buildNodeSelector({
          parentSelector: nodeSelector,
          targetSelector: `> .dnd-grid-background > .${backgroundLayerClassname}`,
          breakpointConfig
        }), 'height: 100%; width: 100%;', mediaQuery]);
        rules.push([buildNodeSelector({
          parentSelector: nodeSelector,
          targetSelector: `> .dnd-grid-background > .${backgroundLayerClassname} > *`,
          breakpointConfig
        }), 'position: absolute;', mediaQuery]);
        backgroundLayerStyles.forEach(([layerSelector, ruleString]) => {
          rules.push([layerSelector, ruleString, mediaQuery]);
        });
      }
      return rules;
    }
    const stylesForBreakpoint = stylesByBreakpointName[breakpointName];
    if (stylesForBreakpoint && stylesForBreakpoint.length > 0) {
      rules.push([selector, stylesForBreakpoint.join(' '), mediaQuery]);
    }
    const backgroundLayerStyles = backgroundLayerStylesByBreakpointName[breakpointName];
    rules.push([buildNodeSelector({
      parentSelector: nodeSelector,
      targetSelector: `> .dnd-grid-background > .${backgroundLayerClassname}`,
      breakpointConfig
    }), 'display: none;', '']);
    if (backgroundLayerStyles && backgroundLayerStyles.length > 0) {
      rules.push([buildNodeSelector({
        parentSelector: nodeSelector,
        targetSelector: `> .dnd-grid-background > :not(.${backgroundLayerClassname})`,
        breakpointConfig
      }), 'display: none;', mediaQuery]);
      rules.push([buildNodeSelector({
        parentSelector: nodeSelector,
        targetSelector: `> .dnd-grid-background > .${backgroundLayerClassname}`,
        breakpointConfig
      }), 'height: 100%; width: 100%; display: block;', mediaQuery]);
      rules.push([buildNodeSelector({
        parentSelector: nodeSelector,
        targetSelector: `> .dnd-grid-background > .${backgroundLayerClassname} > *`,
        breakpointConfig
      }), 'position: absolute;', mediaQuery]);
      backgroundLayerStyles.forEach(([layerSelector, ruleString]) => {
        rules.push([layerSelector, ruleString, mediaQuery]);
      });
    }
    return rules;
  });
}